import React from 'react';
import moment from 'moment'
import { buscarServicoDeBoleto, buscarCustoDoBoleto } from '../../view/formulario/actions/FormBuilderActions'
import { InputField, SelectField, CalendarField, CheckboxField, View, CardSimples, FieldsGroup } from 'react-template';
import { formatarValor } from '../../helpers/Monetario'
import { formatLongToDateHM } from '../../helpers/Data'
import '../../assets/css/components/formbuilder/formPreferences.css'
import { buscarCustoBoleto } from '../../view/gru/actions/GRUActions';

const options = [{ key: 'livre', value: 'LIVRE', text: 'Livre' },
{ key: 'alunos', value: 'ALUNO', text: 'Alunos' },
{ key: 'professores', value: 'PROFESSOR', text: 'Professores' },
{ key: 'tecnicos', value: 'TECNICO', text: 'Técnicos' },
{ key: 'servidores', value: 'SERVIDOR', text: 'Servidores (Professores e Técnicos)' },
{ key: 'academicos', value: 'ACADEMICO', text: 'Acadêmicos (Todos pertencentes à UEPB)' },
{ key: 'chefes', value: 'CHEFE', text: 'Chefes (Chefes de setor e chefes adjuntos)' }
]

class FormPreferences extends View {

    constructor(props) {
        super(props);
        this.setPermissao = this.setPermissao.bind(this);
        this.setServicoBoleto = this.setServicoBoleto.bind(this)
        this.carregarServicoBoleto = this.carregarServicoBoleto.bind(this)
        this.setDataValidade = this.setDataValidade.bind(this);
        this.temLimiteDeInscritos = this.temLimiteDeInscritos.bind(this);
        this.setDataInicio = this.setDataInicio.bind(this);
        this.setCetificado = this.setCetificado.bind(this);
        this.setLimiteDeInscritos = this.setLimiteDeInscritos.bind(this);
        this.setBoleto = this.setBoleto.bind(this);
        this.setValorBoleto = this.setValorBoleto.bind(this);
        this.setDataLimiteBotelo = this.setDataLimiteBotelo.bind(this);
        this.dataMinimaBoleto = this.dataMinimaBoleto.bind(this);
        this.getDataLimiteBoleto = this.getDataLimiteBoleto.bind(this);
        this.setResubmissao = this.setResubmissao.bind(this);
        this.setEvento = this.setEvento.bind(this);
        this.setConfirmarPorEmail = this.setConfirmarPorEmail.bind(this);
        this.setInterno = this.setInterno.bind(this);
        this.dataInicio = null
        this.state = {
            data_minima_boleto: new Date(),
            servicoBoleto: [],
            optionServicoBoleto: [],
            testeBoleto: false,
            checkNVagas: (this.props.limiteDeInscritos > 0)
        };
        this.dataInicialBoleto = new Date();
    }

    componentWillMount() {
        this.carregarServicoBoleto();
    }

    componentDidMount() {
        this.dataMinimaBoleto();
        buscarCustoDoBoleto(res => {
            this.setState({
                ...this.state,
                custo_boleto : res.data
            });
        })
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.limiteDeInscritos !== nextProps.limiteDeInscritos)
            this.setState({ checkNVagas: (nextProps.limiteDeInscritos > 0) })

        if (nextProps.dataInicio !== undefined && nextProps.dataInicio !== null
            && nextProps.dataInicio.length > 0 && this.dataInicio !== nextProps.dataInicio
            && this.dataInicio === null)
            this.dataInicio = nextProps.dataInicio
    }

    setPermissao(e, { value }) {
        this.props.actions.updatePermissao(value);
    }

    setServicoBoleto(e, data) {
        this.props.actions.updateServicoBoleto(data.value + "");
    }

    carregarServicoBoleto() {
        this.getServicosBoleto()
    }

    limparServicoBoleto() {
        this.props.actions.updateServicoBoleto(null);
    }

    setDataValidade(e, data) {
        this.props.actions.updateDataValidade(data.value);
        if (this.props.temBoleto) {
            this.props.actions.updateDataLimiteBoleto(data.value);
        }
        this.dataMinimaBoleto()
    }

    setDataInicio(e, data) {
        this.props.actions.updateDataInicio(data.value);
    }

    setCetificado(e, data) {
        this.props.actions.updateTemCertificado((data.checked));
        if (!(data.checked)) {
            this.props.actions.updateResubmissao(false);
        }
    }

    temLimiteDeInscritos(e, data) {
        if (this.props.limiteDeInscritos > 0) {//if(!this.state.temLimite){
            this.setState({ checkNVagas: false })
            this.props.actions.updateLimiteDeInscritos(0);
            this.forceUpdate();
        } else {
            this.setState({ checkNVagas: true })
            this.props.actions.updateLimiteDeInscritos(1);
            this.forceUpdate();
        }
    }

    setLimiteDeInscritos(e, data) {
        e.preventDefault();
        this.props.actions.updateLimiteDeInscritos(data.value);
    }

    setBoleto(e, data) {
        this.setState({ optionServicoBoleto: { mensagem: false } })
        if (!(data.checked)) { //se não tem boleto
            this.props.notify("Campos de endereço para boleto removidos", "");
            this.props.actions.updateValorBoleto('0,00');
            this.props.actions.updateDataLimiteBoleto('');
            this.props.actions.updateTemBoleto(data.checked);
            this.limparServicoBoleto()
            this.setEvento(e, { checked: false })
        } else {
            this.props.notify("Campos de endereço para boleto adicionados", "");
            this.getServicosBoleto()
            this.dataInicialBoleto = this.getDataLimiteBoleto();
            this.props.actions.updateDataLimiteBoleto(this.props.dataValidade);
            this.props.actions.updateResubmissao(false);
            this.props.actions.updateTemBoleto(data.checked);
        }
    }

    setValorBoleto(e, data) {
        let valor = formatarValor(data.value)
        this.props.actions.updateValorBoleto(valor);
    }

    setDataLimiteBotelo(e, data) {
        this.props.actions.updateDataLimiteBoleto(data.value);
    }

    dataMinimaBoleto() {
        const dataMinima = moment(this.props.dataValidade).format('YYYY/MM/DD')
        this.setState({ ...this.state, data_minima_boleto: new Date(dataMinima) })
    }

    getDataLimiteBoleto() {
        if (this.props.dataLimiteBoleto.trim()) {
            const data = moment(this.props.dataLimiteBoleto).format('YYYY/MM/DD');
            return new Date(data);
        }
    }

    setResubmissao(e, data) {
        this.props.actions.updateResubmissao((data.checked));
    }

    getServicosBoleto() {

        buscarServicoDeBoleto(null, res => {
            let optionServicoBoleto = []
            const servicoBoleto = res.data
            servicoBoleto.forEach(servico => {
                optionServicoBoleto.push({ key: servico.id, value: servico.id + "", text: servico.descricao })
            })

            if (optionServicoBoleto.length === 0) {
                const mensagem = "Nenhum serviço de boleto cadastrado."
                const corMensagem = "flat-blue"
                optionServicoBoleto = { mensagem, corMensagem }
                this.notifyInfo("Sem receita", mensagem)
            }

            this.setState({ ...this.state, servicoBoleto, optionServicoBoleto })
        },
            error => {
                const mensagem = 'Erro ao tentar recuperar receitas. Tente novamente mais tarde.'
                const corMensagem = ""
                let optionServicoBoleto = { mensagem, corMensagem }
                this.setState({ ...this.state, optionServicoBoleto })
                this.notifyError("Erro no serviço de receita", mensagem)
            })

    }

    setEvento(e, data) {
        if ((data.checked)) {
            this.props.notify("Campo de envento foi adicionado", "");
        } else if (this.temEvento()) {
            this.props.notify("Campo de envento removido", "");
        }
        this.props.actions.updateValorBoleto('0,00'); //Quando há evento o valor da inscrição é sempre 0
        this.props.actions.updatePermissao('LIVRE'); //Quando há evento a permissão é sempre LIVRE
        if (((data.checked) & (!this.temEvento())) || ((!data.checked) & (this.temEvento()))) this.props.actions.updateEvento((data.checked));
    }

    setConfirmarPorEmail(e, data) {
        this.props.actions.updateConfirmarPorEmail((data.checked));
    }

    setInterno(e, data) {
        this.props.actions.updateInterno((data.checked));
    }

    temEvento() {
        return this.props.evento > 0;
    }
    dataInicioCadastrada() {
        if (this.dataInicio !== null) {
            return (
                <div className="msg flat-red">
                    Data início cadastrada: {formatLongToDateHM(this.dataInicio)}
                </div>
            )
        }
    }

    render() {
        return (
            <CardSimples titulo="Preferências" borderBottom form>
                <section className="m-l-8">Disponibilização</section>
                <CalendarField
                    name="calendar-range-start"
                    key={'dataInicio'}
                    width={6} phoneWidth={4} tabletWidth={8}
                    value={this.props.dataInicio}
                    invalidMessage="Campo Obrigatório"
                    label='Data Início'
                    required
                    onChange={this.setDataInicio}
                    calendarConfig={{ minDate: new Date() }} />

                <CalendarField
                    name="calendar-range-end"
                    key={'dataFim'}
                    width={6} phoneWidth={4} tabletWidth={8}
                    value={this.props.dataValidade}
                    invalidMessage="Campo Obrigatório"
                    label='Data Fim'
                    required
                    onChange={this.setDataValidade}
                    minDate={this.props.dataInicio}
                    calendarConfig={{ type: "datetime" }}
                    disabled={this.props.dataInicio.trim().length === 0}
                />

                {this.dataInicioCadastrada()}

                <SelectField
                    name="permissão"
                    label='Permissão'
                    placeholder='Selecione uma opção'
                    options={options}
                    invalidMessage="Selecione uma opção"
                    width={12} phoneWidth={4} tabletWidth={8}
                    value={this.props.permissao}
                    onChange={this.setPermissao}
                    disabled={this.temEvento()}
                    required />

                <CheckboxField width={12} phoneWidth={4} tabletWidth={8} rightLabel label='Controle de vagas' value={this.state.checkNVagas} onChange={this.temLimiteDeInscritos} />
                <InputField
                    name="inscritos"
                    key="inscritos"
                    label='Número de inscritos'
                    type='number'
                    pattern="\d*"
                    width={12} phoneWidth={4} tabletWidth={8}
                    disabled={!this.state.checkNVagas}
                    invalidMessage="Informe um número"
                    value={this.props.limiteDeInscritos}
                    required
                    onChange={this.setLimiteDeInscritos} />

                <CheckboxField width={12} phoneWidth={4} tabletWidth={8} rightLabel label='Emissor de certificado' value={this.props.temCertificado} onChange={this.setCetificado} />
                <CheckboxField width={12} phoneWidth={4} tabletWidth={8} rightLabel label='Permitir ressubmissão' value={this.props.resubmissao} onChange={this.setResubmissao} disabled={this.props.temCertificado || this.props.temBoleto} />
                <CheckboxField width={12} phoneWidth={4} tabletWidth={8} rightLabel label='Emissor de boleto' defaultValue={((this.props.temBoleto))} onChange={this.setBoleto} disabled={!(this.props.dataValidade.length)} />
                {(this.state.optionServicoBoleto.mensagem) && (
                    <div className="mdl-textfield invalid touched width-100 p-t-0 m-l-8">
                        <div className={`field-message ${this.state.optionServicoBoleto.corMensagem}`}>{this.state.optionServicoBoleto.mensagem}</div>
                    </div>
                )}
                <SelectField
                    name='select-servico-boleto'
                    id='select-servico-boleto'
                    key='select-servico-boleto'
                    value={this.props.servicoBoleto}
                    options={this.state.optionServicoBoleto}
                    label='Serviço de Boleto'
                    width={12} phoneWidth={4} tabletWidth={8}
                    invalidMessage="Selecione uma opção"
                    onChange={this.setServicoBoleto}
                    required
                    disabled={((!this.props.temBoleto) || ((this.props.temBoleto) && (this.state.optionServicoBoleto.mensagem)))}
                    search={true}
                />
                <FieldsGroup>
                    <CalendarField
                        id='calendario-vencimento'
                        name='calendario-vencimento'
                        key='calendario-vencimento'
                        value={this.props.dataLimiteBoleto}
                        width={4} phoneWidth={4} tabletWidth={4}
                        label='Vencimento'
                        required
                        disabled={((!this.props.temBoleto) || ((this.props.temBoleto) && (this.state.optionServicoBoleto.mensagem)))}
                        onChange={this.setDataLimiteBotelo}
                        calendarConfig={{ type: 'date', minDate: this.state.data_minima_boleto }}
                    />

                    <InputField id='valor-boleto' name='valor-boleto' key='valor-boleto' label='Valor da inscrição '
                        icon='attach_money' width={4} phoneWidth={4} tabletWidth={4} className='money_mask'
                        disabled={(this.temEvento() || (!(this.props.temBoleto) || (this.state.optionServicoBoleto.mensagem)))}
                        value={this.props.valorBoleto} onChange={this.setValorBoleto} />
                    <InputField id='custo-boleto' name='custo-boleto' key='custo-boleto' label='Custo liquidação do Boleto'
                        icon='attach_money' width={4} phoneWidth={4} tabletWidth={4} className='money_mask'
                        disabled={true}
                        value={this.state.custo_boleto}/>
                </FieldsGroup>

                <CheckboxField width={12} phoneWidth={4} tabletWidth={8} rightLabel label='Evento (nome à definir)' value={this.props.evento} onChange={this.setEvento} disabled={!this.props.temBoleto} />
                <CheckboxField width={12} phoneWidth={4} tabletWidth={8} rightLabel label='Confirmar Inscrição por Email' value={this.props.confirmarPorEmail} onChange={this.setConfirmarPorEmail} />
                <CheckboxField width={12} phoneWidth={4} tabletWidth={8} rightLabel label='Formulário Interno' value={this.props.interno} onChange={this.setInterno} />
            </CardSimples>
        );
    }
}

export default FormPreferences;


// WEBPACK FOOTER //
// ./src/components/formbuilder/FormPreferences.js